export enum UsersActionTypes {
  LOAD_USERS_REQUEST = 'LOAD_USERS_REQUEST',
  LOAD_USERS_SUCCEEDED = 'LOAD_USERS_SUCCEEDED',
  LOAD_USERS_FAILED = 'LOAD_USERS_FAILED',
  DELETE_USER_REQUEST = 'DELETE_USER_REQUEST',
  DELETE_USER_SUCCEEDED = 'DELETE_USER_SUCCEEDED',
  DELETE_USER_FAILED = 'DELETE_USER_FAILED',
  LOAD_USER_ATTRIBUTES_REQUEST = 'LOAD_USER_ATTRIBUTES_REQUEST',
  LOAD_USER_ATTRIBUTES_SUCCEEDED = 'LOAD_USER_ATTRIBUTES_SUCCEEDED',
  LOAD_USER_ATTRIBUTES_FAILED = 'LOAD_USER_ATTRIBUTES_FAILED',
  LOAD_ACCESSIBLE_FLEETS_REQUEST = 'LOAD_ACCESSIBLE_FLEETS_REQUEST',
  LOAD_ACCESSIBLE_FLEETS_SUCCEEDED = 'LOAD_ACCESSIBLE_FLEETS_SUCCEEDED',
  LOAD_ACCESSIBLE_FLEETS_FAILED = 'LOAD_ACCESSIBLE_FLEETS_FAILED',
}
